import { emptyString, API_URLS } from "../constants";
import {
  getRequest,
  postRequest,
  putRequest,
} from "../../../system/server-call";
import responseHandler from "../../../system/server-response-handler";

const { SURVEY_INBOX, AZURE_AI } = API_URLS;

const getAllConversations = (
  { search = emptyString, length = 10, filter = emptyString, pageNumber = 0 },
  body
) => {
  return postRequest(
    `${SURVEY_INBOX.BASE}/?Search=${encodeURIComponent(search)}&FilterQuery=${filter}&PageNumber=${pageNumber}&Length=${length}`,
    body
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

const getPreviousConversationDates = ({
  filterQuery,
  body,
  length,
  pageNumber,
}) => {
  return postRequest(
    `${SURVEY_INBOX.GET_PREVIOUS_CONVERSATION_DATES}?filterQuery=${filterQuery}&Length=${length}&PageNumber=${pageNumber}`,
    body
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

const getConversationMessages = (conversationId) => {
  return getRequest(
    `${SURVEY_INBOX.GET_CONVERSATION_MESSAGES}/${conversationId}`
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

const updateCustomerConversationMessages = (body) => {
  return putRequest(SURVEY_INBOX.UPDATE_CUSTOMER_CONVERSATION_MESSAGES, body).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

const saveInternalNotes = (data) => {
  return postRequest(
    SURVEY_INBOX.SAVE_INTERNAL_NOTES_FOR_THE_CONVERSATION,
    data
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

const generateAIResponse = (conversationId) => {
  return getRequest(
    `${AZURE_AI.GENERATE_RESPONSE}/${conversationId}`
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

const reGenerateAIResponse = (responseAction, conversationId) => {
  return getRequest(
    `${AZURE_AI.UPDATE_RESPONSE}/${conversationId}/${responseAction}`
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

const getPreviewCustomerSurvey = (conversationId) => {
  return getRequest(
    `${SURVEY_INBOX.PREVIEW_CUSTOMER_SURVEY}/${conversationId}`
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

const getPreviousInternalNotes = (orderId) => {
  return getRequest(
    `${SURVEY_INBOX.GET_CONVERSATION_INTERNAL_NOTES}/${orderId}`
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

const getCustomerInsights = (brandId, customerId) => {
  return getRequest(
    `${SURVEY_INBOX.GET_CUSTOMER_INSIGHTS}/${customerId}/${brandId}`
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

const getConversationByConversationId = (conversationId) => {
  return getRequest(
    `${SURVEY_INBOX.GET_CONVERSATION}/${conversationId}`
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

const getConversationOrderDetails = (conversationId) => {
  return getRequest(
    `${SURVEY_INBOX.GET_CONVERSATION_ORDER_DETAILS}/${conversationId}`
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

export const inboxServices = {
  saveInternalNotes,
  generateAIResponse,
  getCustomerInsights,
  getAllConversations,
  reGenerateAIResponse,
  getConversationMessages,
  getPreviewCustomerSurvey,
  getPreviousInternalNotes,
  getConversationOrderDetails,
  getPreviousConversationDates,
  getConversationByConversationId,
  updateCustomerConversationMessages,
};
